window.FABME = {
  userPhoto: null,
  userPhotoFile: null,
  selectedProduct: null,
  resultUrl: null
};

window.loadUserPhoto = function(e){
  const file = e.target.files[0];
  if(!file) return;
  window.FABME.userPhotoFile = file;
  const reader = new FileReader();
  reader.onload = function(v){
    window.FABME.userPhoto = v.target.result;
    const preview = document.getElementById('photo-preview');
    const icon = document.querySelector('.upload-icon');
    if(preview){ preview.src = v.target.result; preview.style.display = 'block'; }
    if(icon) icon.style.display = 'none';
    const pt = document.getElementById('photo-text');
    const ps = document.getElementById('photo-sub');
    if(pt) pt.textContent = '✓ Photo uploaded! Click to change';
    if(ps) ps.textContent = 'Looking great! Now select an outfit →';
    const s1 = document.getElementById('step1');
    if(s1) s1.classList.add('done');
    window.updateBtn();
  };
  reader.readAsDataURL(file);
};

window.updateBtn = function(){
  const btn = document.getElementById('tryon-btn');
  const consent = document.getElementById('consent-check');
  if(btn) btn.disabled = !(window.FABME.userPhoto && window.FABME.selectedProduct && consent && consent.checked);
};

window.selectProduct = function(idx){
  const p = (window._prods || [])[idx];
  if(!p) return;
  window.FABME.selectedProduct = p;
  document.querySelectorAll('.prod-card').forEach(c => c.classList.remove('selected'));
  const card = document.querySelector('.prod-card[data-idx="' + idx + '"]');
  if(card) card.classList.add('selected');
  const si = document.getElementById('sel-prod-img');
  const sn = document.getElementById('sel-prod-name');
  const sp = document.getElementById('sel-prod-price');
  const sw = document.getElementById('selected-prod-wrap');
  const img = p.images && p.images[0] ? p.images[0].src : '';
  const price = p.variants && p.variants[0] ? '$' + parseFloat(p.variants[0].price).toFixed(2) : '';
  if(si) si.src = img;
  if(sn) sn.textContent = p.title;
  if(sp) sp.textContent = price;
  if(sw) sw.style.display = 'block';
  const s2 = document.getElementById('step2');
  if(s2) s2.classList.add('done');
  window.updateBtn();
};

window.searchProds = function(q){
  const prods = window._prods || [];
  window.renderProds(q ? prods.filter(p => p.title.toLowerCase().includes(q.toLowerCase())) : prods);
};

window.filterCat = function(cat, el){
  document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('on'));
  el.classList.add('on');
  const prods = window._prods || [];
  const CATS = {
    dress:['dress','gown','maxi','midi','mini'],
    top:['top','blouse','shirt','crop','bodysuit','jacket','blazer'],
    bottom:['pant','jean','legging','short','trouser','skirt'],
    set:['set','coord','co-ord','two piece'],
    swimwear:['swim','bikini','one piece','swimsuit']
  };
  function getCat(p){
    const str = ((p.title||'')+' '+(p.tags||[]).join(' ')+' '+(p.product_type||'')).toLowerCase();
    for(const c in CATS){ if(CATS[c].some(w => str.includes(w))) return c; }
    return 'other';
  }
  window.renderProds(cat === 'all' ? prods : prods.filter(p => getCat(p) === cat));
};

window.renderProds = function(prods){
  const loading = document.getElementById('prod-loading');
  if(loading) loading.style.display = 'none';
  const g = document.getElementById('prod-grid');
  if(!g) return;
  g.style.display = 'grid';
  if(!prods.length){ g.innerHTML = '<div class="ldg">No products found.</div>'; return; }
  g.innerHTML = prods.map((p, i) => {
    const img = p.images && p.images[0] ? p.images[0].src : '';
    const price = p.variants && p.variants[0] ? '$' + parseFloat(p.variants[0].price).toFixed(2) : '';
    return '<div class="prod-card" data-idx="' + i + '" onclick="window.selectProduct(' + i + ')">' +
      (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '<div style="height:100px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;font-size:24px;">👗</div>') +
      '<div class="pinfo"><div class="pname" title="' + p.title + '">' + p.title + '</div><div class="pprice">' + price + '</div></div></div>';
  }).join('');
};

window.generateTryOn = async function(){
  if(!window.FABME.userPhoto || !window.FABME.selectedProduct){
    alert('Please upload a photo and select a product first.');
    return;
  }
  const consent = document.getElementById('consent-check');
  if(!consent || !consent.checked){ 
    alert('Please check the consent box before generating.');
    return; 
  }
  const prodImg = window.FABME.selectedProduct.images && window.FABME.selectedProduct.images[0] ? window.FABME.selectedProduct.images[0].src : '';
  if(!prodImg){ window.showError('This product has no image.'); return; }
  document.getElementById('result-placeholder').style.display = 'none';
  document.getElementById('result-img').style.display = 'none';
  document.getElementById('error-box').style.display = 'none';
  document.getElementById('success-actions').style.display = 'none';
  document.getElementById('loading-wrap').style.display = 'block';
  document.getElementById('tryon-btn').disabled = true;
  document.getElementById('loading-text').textContent = 'Styling your FabMe moment…';
  try{
    const garmentResp = await fetch(prodImg);
    const garmentBlob = await garmentResp.blob();
    const formData = new FormData();
    formData.append('person_image', window.FABME.userPhotoFile, 'person.jpg');
    formData.append('garment_image', garmentBlob, 'garment.jpg');
    formData.append('garment_description', window.FABME.selectedProduct.title);
    const response = await fetch('https://fabmegrabme-tryon.onrender.com/api/tryon', { method: 'POST', body: formData });
    const result = await response.json();
    if(result.success && result.image_url){
      const url = Array.isArray(result.image_url) ? result.image_url[0] : result.image_url;
      window.showResult(url);
    } else {
      window.showError(result.error || 'The mirror had a little fashion emergency. Please try again.');
    }
  } catch(e){
    console.error('Try-on error:', e);
    window.showError('The mirror had a little fashion emergency. Please try again in a moment.');
  }
};

window.showResult = function(url){
  document.getElementById('loading-wrap').style.display = 'none';
  if(url){
    const img = document.getElementById('result-img');
    img.src = url;
    img.style.display = 'block';
    window.FABME.resultUrl = url;
    const s3 = document.getElementById('step3');
    if(s3) s3.classList.add('done');
    document.getElementById('success-actions').style.display = 'flex';
    document.getElementById('tryon-btn').textContent = '✨ Try Another Look';
    document.getElementById('tryon-btn').disabled = false;
  } else {
    window.showError('Could not generate preview. Please try again.');
  }
};

window.showError = function(msg){
  const el = document.getElementById('error-box');
  if(el){ el.textContent = msg; el.style.display = 'block'; }
  const lw = document.getElementById('loading-wrap');
  if(lw) lw.style.display = 'none';
  const btn = document.getElementById('tryon-btn');
  if(btn) btn.disabled = false;
};

window.shopNow = function(){
  if(window.FABME.selectedProduct) window.open('/products/' + window.FABME.selectedProduct.handle, '_blank');
};

window.tryAnother = function(){
  window.FABME.selectedProduct = null;
  window.FABME.resultUrl = null;
  document.querySelectorAll('.prod-card').forEach(c => c.classList.remove('selected'));
  document.getElementById('result-img').style.display = 'none';
  document.getElementById('result-placeholder').style.display = 'block';
  document.getElementById('success-actions').style.display = 'none';
  document.getElementById('selected-prod-wrap').style.display = 'none';
  const s2 = document.getElementById('step2');
  const s3 = document.getElementById('step3');
  if(s2) s2.classList.remove('done');
  if(s3) s3.classList.remove('done');
  document.getElementById('tryon-btn').textContent = '✨ Create My Look';
  window.updateBtn();
};

async function loadProducts(){
  try{
    const r = await fetch('/products.json?limit=250');
    const d = await r.json();
    window._prods = d.products || [];
    window.renderProds(window._prods);
  } catch(e){
    const el = document.getElementById('prod-loading');
    if(el) el.textContent = 'Could not load products.';
  }
}

document.addEventListener('DOMContentLoaded', function(){
  const consent = document.getElementById('consent-check');
  if(consent) consent.addEventListener('change', window.updateBtn);
  if(document.getElementById('prod-grid')) loadProducts();
});